export default __webpack_public_path__ + "static/media/ISO 9K 2027.93646fca.png";